"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadTriggerSource = void 0;
var DownloadTriggerSource;
(function (DownloadTriggerSource) {
    DownloadTriggerSource["CAROUSEL"] = "CAROUSEL";
    DownloadTriggerSource["NOTIFICATIONS"] = "NOTIFICATIONS";
})(DownloadTriggerSource || (exports.DownloadTriggerSource = DownloadTriggerSource = {}));
//# sourceMappingURL=PromoPptRequest.js.map